import { BookOpen, Code, GameController, ImageSquare, MusicNotes, Palette, Sparkle, SquaresFour, Ticket, type Icon } from '@phosphor-icons/react';
import type { CategoryDto } from '@entities/product';
import { HorizontalScroller } from '@shared/ui/HorizontalScroller/HorizontalScroller';
import { haptics } from '@shared/lib/telegram';
import styles from './CategoryRail.module.css';

const categoryIcons: Array<[RegExp, Icon]> = [
  [/ai|prompt|intelligence/i, Sparkle], [/template|design|creative|graphic/i, Palette],
  [/software|code|tool|app/i, Code], [/learning|education|course|book|guide/i, BookOpen],
  [/game|gaming/i, GameController], [/music|audio|sound/i, MusicNotes],
  [/subscription|membership|gift|credit/i, Ticket], [/photo|image|asset/i, ImageSquare],
];
function iconFor(category: CategoryDto): Icon {
  return categoryIcons.find(([pattern]) => pattern.test(`${category.slug} ${category.name}`))?.[1] ?? SquaresFour;
}
export function CategoryRail({ categories, value, onChange }: { categories: CategoryDto[]; value: string; onChange: (id: string) => void }) {
  const items = [{ id: '', name: 'All products', icon: SquaresFour }, ...categories.map(category => ({ ...category, icon: iconFor(category) }))];
  return <HorizontalScroller title="Shop by category" itemWidth="80px" showControls={false}>
    {items.map(({ id, name, icon: Icon }) => <button key={id} type="button" className={styles.category} aria-pressed={value === id} onClick={() => { haptics.select(); onChange(id); }}>
      <span className={styles.icon}><Icon size={22} weight={value === id ? 'fill' : 'regular'} /></span><span className={styles.name}>{name}</span>
    </button>)}
  </HorizontalScroller>;
}
